import React from "react";
import FormAvatar from "UI/Form/FormAvatar";
import UpitIcon from "Icons/UpitIcon";

function UpitAvatar() {
  return <FormAvatar ariaLabel="ponuda" icon={<UpitIcon />} />;
}

export default UpitAvatar;
